var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoIssueMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C3F119AE-D6A3-4B88-940A-14F5E8152738") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,0 C12.544,0 0,12.544 0,28 C0,43.456 12.544,56 28,56 C43.456,56 56,43.456 56,28 C56,12.544 43.456,0 28,0 Z M27.9999995,50.3999991 C15.6519997,50.3999991 5.5999999,40.3479993 5.5999999,27.9999995 C5.5999999,15.6519997 15.6519997,5.5999999 27.9999995,5.5999999 C40.3479993,5.5999999 50.3999991,15.6519997 50.3999991,27.9999995 C50.3999991,40.3479993 40.3479993,50.3999991 27.9999995,50.3999991 Z M38.8640012,17.6119993 L22.4000007,34.0759993 L17.1360006,28.8119993 C16.6128723,28.2876918 15.9026499,27.9930396 15.1620005,27.9930396 C14.4213511,27.9930396 13.7111287,28.2876918 13.1880005,28.8119993 C12.0960004,29.9039993 12.0960004,31.6679993 13.1880005,32.7599993 L20.4400007,40.0119994 C21.5320007,41.1039994 23.2960008,41.1039994 24.3880008,40.0119994 L42.8400013,21.5599993 C43.9320014,20.4679993 43.9320014,18.7039993 42.8400013,17.6119993 C41.7480013,16.5199993 39.9560012,16.5199993 38.8640012,17.6119993 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "7_Issue-Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Comments-Entered",
    transform: "translate(-984.000000, -172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Classify-Asset-Class-Header",
    transform: "translate(0.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Results-Detail-/-Icon-/-No-Issue",
    transform: "translate(984.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "No-issue-icon",
    fill: "#8DA656",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIssueMd);
export default __webpack_public_path__ + "static/media/no-issue-md.1328271fc29635e8bfb432cea8940c63.svg";
export { ForwardRef as ReactComponent };